export enum DiffusionStatusEnum {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  AVAILABLE = 'AVAILABLE',
  DIFFUSED = 'DIFFUSED'
}
